module.exports = __webpack_public_path__ + "img/tj.ab3bac6.svg";